module.exports = __webpack_public_path__ + "static/media/cariboudevform.dbf7178d.png";